import { render, staticRenderFns } from "./PreDistribution.vue?vue&type=template&id=167431ed"
import script from "./PreDistribution.vue?vue&type=script&lang=js"
export * from "./PreDistribution.vue?vue&type=script&lang=js"
import style0 from "./PreDistribution.vue?vue&type=style&index=0&id=167431ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports